// Product modules enabled in this deployment. The shell renders their navigation and mounts their routes.
import type { ProductWeb } from '@lumlab/platform-product/web';
import { tendersWeb } from '@lumlab/tenders/web';

export const products: readonly ProductWeb[] = [tendersWeb];
